import React from "react";

function Slider() {
  return (
    <section id="hero">
      <div className="hero-container" data-aos="fade-up">
        <h2 style={{ textTransform: "capitalize" }}>Talaşlı İmalat</h2>
        <a href="#portfolio" className="btn-get-started scrollto">
          <i className="bx bx-chevrons-down"></i>
        </a>
      </div>
    </section>
  );
}

export default Slider;